import type { ReactNode } from 'react'

/* Given a React Element and a function that evaluates whether this element should be displayed (see type Announcement),
   this abstraction calls the function and handles the showing of the element accordingly */

export type Announcement = {
    evaluateVisibility: () => boolean
    component: ReactNode
    description: string
}

export const UserAnnouncementPlacement = () => {
    const declaredAnnouncements: Announcement[] = []

    // We wrap the component in a fragment to satisfy the JSX return type
    for (const announcement of declaredAnnouncements) {
        if (announcement.evaluateVisibility()) {
            return <>{announcement.component}</>
        }
    }

    return null
}
